export enum enStatusWaiter {
  IDLE = 'idle',
  RUNNING = 'running',
  WAITING = 'waiting',
  CANCELED = 'canceled',
  PAID = 'paid',
  TIMEOUT = 'timeout'
}
